import React from "react";
import styles from "./active-clients-section.module.scss";
import { ActiveClientItem } from "./active-client-item";

// Hardcoded data for fallback
const defaultMspData = [
  {
    rank: 1,
    name: "Cantozil",
    avatar: "/images/user-logo.svg",
    distributor: {
      name: "HighGround",
      icon: null,
    },
    plan: "Plan 1",
    revenue: "€ 8209.00 EUR /mo",
  },
  {
    rank: 2,
    name: "Starbucks",
    avatar: "/images/user-logo.svg",
    distributor: {
      name: "HighGround",
      icon: null,
    },
    plan: "Plan 1",
    revenue: "$ 4324.00 USD /mo",
  },
  {
    rank: 3,
    name: "Capital Techies",
    avatar: "/images/user-logo.svg",
    distributor: {
      name: "Portland",
      icon: null,
    },
    plan: "Plan 1",
    revenue: "€ 4324.00 /mo",
  },
  {
    rank: 4,
    name: "Target",
    avatar: "/images/user-logo.svg",
    distributor: {
      name: "Virosafe",
      icon: null,
    },
    plan: "Plan 1",
    revenue: "€ 4324.00 /mo",
  },
  {
    rank: 5,
    name: "Carden IT Group",
    avatar: "/images/user-logo.svg",
    distributor: {
      name: "Portland",
      icon: null,
    },
    plan: "Plan 1",
    revenue: "€ 4324.00 /mo",
  },
  {
    rank: 6,
    name: "Mail Chimp",
    avatar: "/images/user-logo.svg",
    distributor: {
      name: "Portland",
      icon: null,
    },
    plan: "Plan 1",
    revenue: "€ 4324.00 /mo",
  },
  {
    rank: 7,
    name: "Chalkline",
    avatar: "/images/user-logo.svg",
    distributor: {
      name: "Brigantia",
      icon: null,
    },
    plan: "Plan 1",
    revenue: "€ 4324.00 /mo",
  },
  {
    rank: 8,
    name: "Asda",
    avatar: "/images/user-logo.svg",
    distributor: {
      name: "Portland",
      icon: null,
    },
    plan: "Plan 1",
    revenue: "€ 4324.00 /mo",
  },
  {
    rank: 9,
    name: "Delego",
    avatar: "/images/user-logo.svg",
    distributor: {
      name: "Virosafe",
      icon: null,
    },
    plan: "Plan 1",
    revenue: "€ 4324.00 /mo",
  },
  {
    rank: 10,
    name: "Shell",
    avatar: "/images/user-logo.svg",
    distributor: {
      name: "Brigantia",
      icon: null,
    },
    plan: "Plan 1",
    revenue: "€ 4324.00 /mo",
  },
];

export const ActiveClientsSection = ({ activeMSPAccounts, isV2 = true, mspData = [], isDistributor = true }) => {
  // First check: if not v2, show block (return early)
  if (!isV2) {
    const rawItems = activeMSPAccounts?.slice(0, 10) || [];
    const items = rawItems.length > 0 ? rawItems : defaultMspData;
    const title = "Top 10 active MSP's";
    
    // Single column layout for non-v2
    return (
      <section className={styles.section}>
        <header className={styles.header}>
          <div className={styles.headerContent}>
            <h2 className={styles.title}>
              {title}
            </h2>
          </div>
        </header>

        <div className={styles.content}>
          <ul className={styles.list}>
            {items.map((item, index) => {
              const rank = index + 1;
              return (
                <ActiveClientItem
                  key={rank}
                  item={item}
                  rank={rank}
                />
              );
            })}
          </ul>
        </div>
      </section>
    );
  }

  // Determine data source
  const rawItems = (isDistributor && mspData && mspData.length > 0) 
    ? mspData 
    : (activeMSPAccounts?.slice(0, 10) || []);
  
  // Use hardcoded data if no items available
  const items = rawItems.length > 0 ? rawItems : defaultMspData;

  const title = isDistributor 
    ? "Top 10 Most Active MPS's" 
    : "Top 10 Most Active";

  // If isDistributor is true, show two column list
  if (isDistributor) {
    // Two column layout for distributor view
    const leftColumn = items.filter((_, index) => (index + 1) % 2 === 1);
    const rightColumn = items.filter((_, index) => (index + 1) % 2 === 0);

    return (
      <section className={styles.section}>
        <header className={styles.header}>
          <div className={styles.headerContent}>
            <h2 className={styles.title}>
              {title}
            </h2>
          </div>
        </header>

        <div className={styles.content}>
          <ul className={styles.list} data-column="left">
            {leftColumn.map((item, index) => {
              const rank = index * 2 + 1;
              return (
                <ActiveClientItem
                  key={rank}
                  item={item}
                  rank={rank}
                />
              );
            })}
          </ul>
          <ul className={styles.list} data-column="right">
            {rightColumn.map((item, index) => {
              const rank = (index + 1) * 2;
              return (
                <ActiveClientItem
                  key={rank}
                  item={item}
                  rank={rank}
                />
              );
            })}
          </ul>
        </div>
      </section>
    );
  }

  // If isDistributor is false, show table with MSP, Distributor, Plan, Monthly Revenue
  // Map items to table format
  const mappedTableData = items.map((item, index) => {
    // If item already has rank, it's already in the correct format (from mspData or defaultMspData)
    if (item.rank !== undefined) {
      return item;
    }
    
    // Get default data for fallback
    const defaultItem = defaultMspData[index % defaultMspData.length];
    
    // Otherwise, map from activeMSPAccounts structure (uses Label and icon)
    return {
      rank: index + 1,
      name: item.Label || item.name || defaultItem?.name || "Unknown",
      avatar: item.icon || item.avatar || defaultItem?.avatar || "/images/user-logo.svg",
      distributor: item.distributor || { 
        name: item.distributorName || defaultItem?.distributor?.name || "Unknown", 
        icon: item.distributorIcon || defaultItem?.distributor?.icon || null 
      },
      plan: item.plan || item.planName || defaultItem?.plan || "Plan 1",
      revenue: item.revenue || item.revenueValue || item.monthlyRevenue || defaultItem?.revenue || "€ 0.00 /mo",
    };
  });

  return (
    <section className={styles.section}>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <h2 className={styles.title}>
            {title}
          </h2>
        </div>
      </header>

      <div className={styles.mspTableHeader} role="row">
        <div className={styles.mspTableHeaderCell}>MSP</div>
        <div className={styles.mspTableHeaderCell}>Distributor</div>
        <div className={styles.mspTableHeaderCell}>Plan</div>
        <div className={styles.mspTableHeaderCell}>Monthly Revenue</div>
      </div>

      <div className={styles.mspTableContent}>
        {mappedTableData.map((msp, index) => (
          <div
            key={msp.id || msp.rank || index}
            className={styles.mspTableRow}
            role="row"
          >
            <div className={styles.mspTableCell}>
              <span className={styles.mspRank}>
                {msp.rank || (index + 1)}
              </span>
              <div className={styles.mspNameContainer}>
                <img
                  className={styles.mspAvatar}
                  src={msp.avatar || msp.icon || "/images/user-logo.svg"}
                  alt={msp.name || msp.Label}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "/images/user-logo.svg";
                  }}
                />
                <span className={styles.mspName}>
                  {msp.name || msp.Label}
                </span>
              </div>
            </div>

            <div className={styles.mspTableCell}>
              {msp.distributor?.icon}
              <span className={styles.mspDistributorName}>
                {msp.distributor?.name || defaultMspData[index % defaultMspData.length]?.distributor?.name || "Unknown"}
              </span>
            </div>

            <div className={styles.mspTableCell}>
              <div className={styles.mspPlanBadge}>
                {msp.plan || defaultMspData[index % defaultMspData.length]?.plan || "Plan 1"}
              </div>
            </div>

            <div className={styles.mspTableCell}>
              {(() => {
                const revenue = msp.revenue || msp.revenueValue || defaultMspData[index % defaultMspData.length]?.revenue || "€ 0.00 /mo";
                // Split revenue value and /mo
                const parts = revenue.split(/\s*\/mo\s*/);
                const value = parts[0] || "";
                const hasMo = revenue.includes("/mo");
                
                return (
                  <span className={styles.mspRevenue}>
                    <span className={styles.mspRevenueValue}>
                      {value}
                    </span>
                    {hasMo && (
                      <span className={styles.mspRevenueMo}>
                        {" /mo"}
                      </span>
                    )}
                  </span>
                );
              })()}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
